// src/pages/TarifYonetim.js

import React, { useState, useEffect } from 'react';
import { Plus, Edit3, Trash2, ImageOff } from 'lucide-react';
import { callApi, callPublicApi } from '../api';
import RecipeVisualEditor from '../components/RecipeVisualEditor';
import './YonetimSayfasi.css';

const TarifYonetim = ({ kulup }) => {
    const [tarifler, setTarifler] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [tarifToEdit, setTarifToEdit] = useState(null);

    useEffect(() => {
        fetchTarifler();
    }, [kulup]);

    // Tarifleri API'den çeken fonksiyon
    const fetchTarifler = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const query = kulup?.kulupID ? `?kulupID=${kulup.kulupID}` : '';
            const data = await callPublicApi(`/recipes${query}`);

            let parsedBody = [];
            if (data && data.body) {
                const bodyParse = JSON.parse(data.body);
                parsedBody = bodyParse.items || bodyParse;
            } else if (data && data.items) {
                parsedBody = data.items;
            } else if (Array.isArray(data)) {
                parsedBody = data;
            } else {
                console.warn("Tarif verisi beklenen formatta değil:", data);
                parsedBody = [];
            }

            const tarifItems = Array.isArray(parsedBody) ? parsedBody : parsedBody.items || [];
            tarifItems.sort((a, b) => (a.ad || '').localeCompare(b.ad || ''));

            setTarifler(tarifItems);
        } catch (err) {
            console.error("Tarif yükleme hatası:", err);
            setError("Tarifler yüklenemedi. API Key ayarınızı kontrol edin veya Lambda fonksiyonunda bir hata olabilir.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (recipeId) => {
        if (!window.confirm("Bu tarifi silmek istediğinizden emin misiniz?")) {
            return;
        }

        setIsLoading(true);
        setError(null);
        try {
            await callApi(`/recipes?recipeId=${recipeId}`, 'DELETE');
            fetchTarifler();
        } catch (err) {
            setError(err.message || "Tarif silme işlemi başarısız oldu.");
            setIsLoading(false);
        }
    };

    const handleEdit = (tarif) => {
        setTarifToEdit(tarif);
        setIsFormOpen(true);
    };

    const handleFormSave = () => {
        setIsFormOpen(false);
        setTarifToEdit(null);
        fetchTarifler();
    };

    if (isLoading && tarifler.length === 0 && !error) return <div className="loading-state">Tarifler Yükleniyor...</div>;
    if (error) return <div className="error-state">Hata: {error}</div>;

    return (
        <div className="yonetim-sayfasi">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' }}>
                <div>
                    <h2 style={{ marginBottom: '4px' }}>Tarif Yönetimi</h2>
                    <p style={{ color: '#94a3b8', fontSize: '0.78rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', margin: 0 }}>Görsel Tarif Hazırlama Merkezi</p>
                </div>
                <button className="primary-button" onClick={() => { setTarifToEdit(null); setIsFormOpen(true); }}>
                    <Plus size={18} /> Yeni Tarif Ekle
                </button>
            </div>

            {/* Tarif Ekleme/Düzenleme Formu Modal'ı */}
            {isFormOpen && (
                <div className="modal-overlay">
                    <div className="modal-content modal-content-recipe">
                        <RecipeVisualEditor
                            tarifToEdit={tarifToEdit}
                            kulup={kulup}
                            onSave={handleFormSave}
                            onCancel={() => setIsFormOpen(false)}
                        />
                    </div>
                </div>
            )}

            {/* Tarif Listesi — Card-Based */}
            <div className="admin-card-grid">
                {tarifler.length > 0 ? (
                    tarifler.map((tarif) => (
                        <div key={tarif.recipeId} className="admin-card">
                            {/* Üst Görsel */}
                            <div className="admin-card-image">
                                {(tarif.resimUrl || tarif.imageBase64) ? (
                                    <img src={tarif.resimUrl || tarif.imageBase64} alt={tarif.ad} />
                                ) : (
                                    <div className="admin-card-image-placeholder">
                                        <ImageOff size={28} />
                                    </div>
                                )}
                                {tarif.kategori && (
                                    <span className="admin-card-badge">{tarif.kategori}</span>
                                )}
                            </div>

                            {/* İçerik */}
                            <div className="admin-card-body">
                                <h4 className="admin-card-title">{tarif.ad}</h4>
                                {tarif.aciklama && (
                                    <p className="admin-card-desc">{tarif.aciklama.substring(0, 80)}{tarif.aciklama.length > 80 ? '...' : ''}</p>
                                )}
                            </div>

                            {/* Aksiyonlar */}
                            <div className="admin-card-actions">
                                <button onClick={() => handleEdit(tarif)} className="admin-action-btn admin-action-edit" title="Düzenle">
                                    <Edit3 size={16} /> Düzenle
                                </button>
                                <button onClick={() => handleDelete(tarif.recipeId)} className="admin-action-btn admin-action-delete" title="Sil">
                                    <Trash2 size={16} /> Sil
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="admin-card-empty">
                        Henüz eklenmiş tarif bulunmamaktadır.
                    </div>
                )}
            </div>
        </div>
    );
};

export default TarifYonetim;